import { Injectable } from '@angular/core';
import { AuthorizedPersonnelModel } from '../model';
import { PersonnelAppointment } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class ApplicationHelperService {
  static isPersonnelKeyman(personnel: AuthorizedPersonnelModel): boolean {
    return personnel.appointment?.includes(PersonnelAppointment.KEYMAN) || false;
  }

  /**
   * Business Rule:
   *
   * Have only one Keyman in Personnel
   *
   * Only the Personnel appointed as Keyman can edit the Personnel List
   *
   * The Keyman cannot be deleted.
   *
   * @param personnels Array of personnel to be sorted.
   * @returns Sorted array of personnel with Keyman first.
   */
  static sortPersonnelByKeyman(personnels: AuthorizedPersonnelModel[]): AuthorizedPersonnelModel[] {
    // personnels.reverse();
    return personnels.sort((a, b) => {
      if (this.isPersonnelKeyman(a) && !this.isPersonnelKeyman(b)) {
        return -1;
      }
      if (!this.isPersonnelKeyman(a) && this.isPersonnelKeyman(b)) {
        return 1;
      }
      return 0;
    });
  }
}
